<div class="login">
    <div class="login-card">
        @if (isNewPasswordRequired()) {
            <h4 class="login-heading">Set New Password</h4>
            <p class="login-subheading">
                Your account requires a new password before you can continue.
                Please choose a strong password below.
            </p>

            <form
                [formGroup]="newPasswordForm"
                (ngSubmit)="onSetNewPassword()"
                class="login-form"
            >
                <tools-input-outline
                    label="New Password"
                    placeholder="Enter new password"
                    formControlName="newPassword"
                    [isPassword]="true"
                    [showVisibilityIcon]="true"
                ></tools-input-outline>

                @if (newPasswordStarted) {
                    <ul class="password-requirements">
                        @for (req of newPasswordRequirements; track req.label) {
                            <li [class.met]="req.met" [class.unmet]="!req.met">
                                @if (req.met) {
                                    <span class="icon-check"></span>
                                } @else {
                                    <span class="icon-placeholder"></span>
                                }
                                {{ req.label }}
                            </li>
                        }
                    </ul>
                }

                <tools-input-outline
                    label="Confirm New Password"
                    placeholder="Confirm new password"
                    formControlName="confirmPassword"
                    [isPassword]="true"
                    [showVisibilityIcon]="true"
                ></tools-input-outline>

                @if (
                    newPasswordForm.errors?.["passwordsMismatch"] &&
                    newPasswordForm.get("confirmPassword")?.touched
                ) {
                    <p class="field-error">Passwords do not match.</p>
                }

                <tools-button
                    [type]="ButtonType.SUBMIT"
                    [isDisabled]="isNewPasswordSubmitDisabled"
                >
                    Set Password
                </tools-button>
            </form>
        } @else {
            <h4 class="login-heading">Log In</h4>

            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login-form">
                <tools-input-outline
                    label="Email"
                    placeholder="Enter email"
                    formControlName="email"
                ></tools-input-outline>

                <tools-input-outline
                    label="Password"
                    placeholder="Enter password"
                    formControlName="password"
                    [isPassword]="true"
                    [showVisibilityIcon]="true"
                ></tools-input-outline>

                <tools-button
                    [type]="ButtonType.SUBMIT"
                    [isDisabled]="isSubmitDisabled"
                >
                    Log In
                </tools-button>
            </form>
            <a routerLink="/forgot-password">Forgot password?</a>
        }
    </div>

    <div class="login-secondary">
        <p>
            SiriusXM employee?
            <a href="#" (click)="signInWithOkta(); $event.preventDefault()">
                Sign in with SSO
            </a>
        </p>
    </div>
</div>
